<div class="headline">
  <span class="mat-h1 m0" id="headline-user-management">Nutzerverwaltung</span>
</div>
<hr>

  <div class="main-content-wrapper" style="margin-top: 1rem;">
    <div class="mat-elevation">
      <div class="user-management-content">
        <mat-form-field appearance="outline" style="width: 95%; padding: 10px; margin-bottom: -1rem; margin-top: 1rem;">
          <mat-label>Nutzer suchen</mat-label>
          <!-- TODO test this with form control -->
          <input (input)="searchUsers()" [formControl]="inputString" matInput placeholder="" type="text">
        </mat-form-field>


        <div style="max-height: 80%; overflow-y: auto;" class="w100">
          <table [dataSource]="data" class="custom-scrollbar w100" mat-table matSort matSortActive="created"
            matSortDirection="desc" matSortDisableClear style="max-height: 350px; overflow-y: auto">

            <ng-container matColumnDef="name">
              <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header>Nachname</th>
              <td *matCellDef="let row" mat-cell>{{row.lastName}}</td>
            </ng-container>

            <ng-container matColumnDef="firstName">
              <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header>Vorname</th>
              <td *matCellDef="let row" mat-cell>{{row.firstName}}</td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header>E-Mail</th>
              <td *matCellDef="let row" mat-cell>{{row.email}}</td>
            </ng-container>

            <ng-container matColumnDef="role">
              <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header>Rolle</th>
              <td *matCellDef="let row" mat-cell>{{transformRoleName(row.role)}}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th *matHeaderCellDef mat-header-cell>Rolle ändern</th>
              <td *matCellDef="let row" mat-cell>
                <button
                  (click)="editUser(row)"
                  class="edit-button-table"
                  color="primary"
                  mat-icon-button
                  matTooltip="Rolle ändern"
                  matTooltipShowDelay="1000"
                  matTooltipPosition="right"
                  matTooltipHideDelay="200">
                  <mat-icon color="primary">open_in_new</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="locked">
              <th *matHeaderCellDef mat-header-cell>Status</th>
              <td *matCellDef="let row" mat-cell>
                <button
                  (click)="toggleStatus(row)"
                  class="edit-button-table"
                  color="primary"
                  mat-icon-button
                  matTooltip="Nutzer (ent)sperren"
                  matTooltipShowDelay="1000"
                  matTooltipPosition="right"
                  matTooltipHideDelay="200">
                  @if (!row.isLocked) {
                    <mat-icon color="primary">lock_open</mat-icon>
                  }
                  @if (row.isLocked) {
                    <mat-icon color="warn">lock</mat-icon>
                  }
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="delete">
              <th *matHeaderCellDef mat-header-cell>Löschen</th>
              <td *matCellDef="let row" mat-cell>
                <button
                  (click)="deleteUser(row)"
                  class="edit-button-table"
                  color="warn"
                  mat-icon-button
                  matTooltip="Nutzer löschen"
                  matTooltipShowDelay="1000"
                  matTooltipPosition="right"
                  matTooltipHideDelay="200">
                  <mat-icon color="warn">delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
            <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>

            @if (inputString.getRawValue() !== '' && data?.length < 1) {
              <tr class="mat-row">
                <td class="mat-cell" colspan="4">Keine Treffer für Eingabe gefunden: "{{inputString}}"</td>
              </tr>
            }

          </table>
        </div>

        <div style="background-color: white; flex-grow: 1"></div>

        <mat-paginator style="margin-bottom: 1rem;" [length]="resultsLength" [pageSizeOptions]="[25, 50, 100]" [pageSize]="25"
        showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </div>


  <!-- TODO delete?
  <div class="mat-elevation-z8"
    style="display: flex; flex-direction: column; background-color: white; justify-content: space-between; align-items: center; margin-bottom: 2rem; padding-left: 2rem; padding-right: 2rem;"style="display: flex; flex-direction: column; background-color: white; justify-content: space-between; align-items: center; margin-bottom: 2rem; padding-left: 2rem; padding-right: 2rem;">

    <mat-form-field appearance="outline" style="width: 95%; padding: 10px;">
      <mat-label>Nutzer suchen</mat-label>
      <input (input)="searchUsers()" [(ngModel)]="inputString" matInput placeholder="" type="text">
    </mat-form-field>


    <div style="max-height: 450px; overflow-y: auto; width: 100%;">
      <table [dataSource]="data" class="custom-scrollbar" mat-table matSort matSortActive="created"
        matSortDirection="desc" matSortDisableClear style="width: 100%; max-height: 350px; overflow-y: auto">

        <ng-container matColumnDef="name">
          <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header>Nachname</th>
          <td *matCellDef="let row" mat-cell>{{row.name}}</td>
        </ng-container>

        <ng-container matColumnDef="firstName">
          <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header>Vorname</th>
          <td *matCellDef="let row" mat-cell>{{row.firstName}}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header>E-Mail</th>
          <td *matCellDef="let row" mat-cell>{{row.email}}</td>
        </ng-container>

        <ng-container matColumnDef="role">
          <th *matHeaderCellDef disableClear mat-header-cell mat-sort-header>Rolle</th>
          <td *matCellDef="let row" mat-cell>{{transformRoleName(row.role)}}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th *matHeaderCellDef mat-header-cell>Rolle ändern</th>
          <td *matCellDef="let row" mat-cell>
            <button (click)="editUser(row)" class="edit-button-table" color="primary" mat-icon-button
              title="edit-button">
              <mat-icon color="primary">open_in_new</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="locked">
          <th *matHeaderCellDef mat-header-cell>Status</th>
          <td *matCellDef="let row" mat-cell>
            <button (click)="toggleStatus(row)" class="edit-button-table" color="primary" mat-icon-button
              title="lock-button">
              <mat-icon *ngIf="!row.isLocked" color="primary">lock_open</mat-icon>
              <mat-icon *ngIf="row.isLocked" color="warn">lock</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="delete">
          <th *matHeaderCellDef mat-header-cell>Löschen</th>
          <td *matCellDef="let row" mat-cell>
            <button (click)="deleteUser(row)" class="edit-button-table" color="warn" mat-icon-button
              title="delete-button">
              <mat-icon color="warn">delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>

        <tr *ngIf="inputString !== '' && data?.length < 1" class="mat-row">
          <td class="mat-cell" colspan="4">Keine Treffer für Eingabe gefunden: "{{inputString}}"</td>
        </tr>

      </table>
    </div>

    <div style="background-color: white; flex-grow: 1"></div>

    <mat-paginator [length]="resultsLength" [pageSizeOptions]="[25, 50, 100]" [pageSize]="25"
    showFirstLastButtons></mat-paginator>
  </div>
  -->
